module.exports = __webpack_public_path__ + "img/csr-sb1-1.c7776e5d.jpg";